//@ts-check
import * as THREE from "three";

/**
 * @module Highlight
 */


/**
 * Hightlight Event
 * @param {MouseEvent} event - Mouse event
 * @param {Object} callBack - call back intersected object name
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function highlightElement(event, callBack) {
  var scope = this;
  
  try {
    if (event.buttons == 0) {
      if ((event != undefined || event != null) && (callBack != undefined || callBack != null)) {
        scope.raycastSetup(event);
        if (scope.highlightElementFlagCheck) {
          var intersected = scope.raycaster.intersectObject(scope.modelScene, true);
          
          if (intersected.length > 0) {
            let object = intersected[0].object
            if (!object.isClipped){
              scope.applyHighlightMaterial(intersected[0].object.name);     
              scope.formatTooltipOn(event);
              scope.formatTooltipMove(event);
              callBack(intersected[0].object.name);
            }
          }
          else {
            scope.formatTooltipOff();
            scope.clearHighlights()
          }
        }
        //viewerMgrInstance.render();
        var returnValue = {
          "status": "success",
          "message": "Element is highlighted successfully."
        }
        return returnValue;
      }
      else {
        var returnValue = {
          "status": "failed",
          "message": "ERROR : Event or callback is either undefined or null."
        }
        return returnValue;
      }
    }
    else {
      scope.isDragged = true;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": 'System Error: ' + err.message
    }
    return returnValue;
  }
}

/**
 * Applies hightlight material to a single element 
 * @param {string} element_ID - Element unique id
 * @param {boolean} [render = false] - Render or not ?
 * @returns {Object} Status object
 */
export function applyHighlightMaterial(element_ID, render = false) {
  const scope = this;
  try {
    const child = scope.elementsMap.get(element_ID);
    

    // Store original material once if not already stored
    if (!child.userData.originalMaterial) {
      child.userData.originalMaterial = child.material;
    }

    // Remember if the element was ghosted before highlighting
    if (child.userData.ghosted) {
      child.userData._wasGhosted = true;
    }

    // Save current material state before highlighting
    if (!child.userData._tempMaterial) {
      child.userData._tempMaterial = child.material;
    }
    
    if (child.userData.filtered) {
      // Remember that this element is filtered
      child.userData._wasFiltered = true;
      child.userData._filteredOpacity = child.userData.opacity || 0.3;
    }

    // Apply highlight material
    child.material = scope.highlightMaterial;
    
    if (scope.clipActive) {
      child.material.clippingPlanes = scope.clippingPlanes;
      child.material.clipShadows = scope.clipShadows;
      child.material.clipIntersection = scope.clipIntersection;
    }
    
    scope.highLightArray.push(child);

    if (render) {
      this.viewerMgrInstance.render();
    }
    
    return { status: 'success', message: 'Highlight material applied' };
  } catch (err) {
    return { status: 'failed', message: err.message };
  }
}

/**
 * Applies highlight materials to multiple element
 * @param {Array<string>} element_Ids - Array of element ids 
 * @param {boolean} [render = false] - Render or not ?
 * @returns {Object} - Return success or error messages 
 * { status:  mesage: }
 */
export function applyHighlightMaterials(element_Ids, render = false) {
  var scope = this;
  try {

    if (scope.modelScene.children.length != 0 && element_Ids.length >= 1) {

      for (let i = 0; i < element_Ids.length; i++) {
        scope.applyHighlightMaterial(element_Ids[i]);
      }

      if (render) {
        this.viewerMgrInstance.render();
      }

      var returnValue = {
        "status": "success",
        "message": "Lock elements API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Load the model in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error: " + err.message
    }
    return returnValue;
  }
}


/**
 * Clear all highlights and restore previous materials
 * Resets highlighted elements in scope.highLightArray 
 * @param {boolean} [render = false] - Render or not ?
 * @returns {Object} - Return success or error messages 
 * { status:  mesage: }
 */
export function clearHighlights(render = false) {
  const scope = this;
  try {
    // For each highlighted element, restore its previous state
    scope.highLightArray.forEach(child => {
      if (child) {
        // If this element is selected, don't restore original material
        if (child.userData.selectMaterial) {
          // Just keep the selection material
          child.material = child.userData.selectMaterial;
        }
        // If it was ghosted before highlighting, restore ghost material
        else if (child.userData._wasGhosted) {
          child.material = scope.ghostMaterial;
          child.userData.ghosted = true;
          // Clean up temporary ghost state
          delete child.userData._wasGhosted;
        }
        // Otherwise restore based on filtered status
        else if (child.userData._wasFiltered) {
          // If it was filtered, reapply the filter effect
          if (child.userData.colorMaterial) {
            // Was colored and filtered
            if (!child.userData.fadedMaterial) {
              child.userData.fadedMaterial = child.userData.colorMaterial.clone();
            }
            child.material = child.userData.fadedMaterial;
          } else {
            // Was just filtered
            if (!child.userData.fadedMaterial) {
              child.userData.fadedMaterial = child.userData.originalMaterial.clone();
            }
            child.material = child.userData.fadedMaterial;
          }
          // Restore opacity
          child.material.transparent = true;
          child.material.opacity = child.userData._filteredOpacity;
          child.userData.filtered = true;
          
          // Clean up temporary state
          delete child.userData._wasFiltered;
          delete child.userData._filteredOpacity;
        } else if (child.userData.colorMaterial) {
          // Was just colored, not filtered
          child.material = child.userData.colorMaterial;
        } else if (child.userData._tempMaterial) {
          // Restore temporarily stored material
          child.material = child.userData._tempMaterial;
          delete child.userData._tempMaterial;
        } else {
          // Had no special state - always restore original material
          child.material = child.userData.originalMaterial;
        }
      }
    });
    
    scope.highLightArray = [];
    if (render) this.viewerMgrInstance.render();
    
    return {
      "status": "success",
      "message": "Cleared the highlighted element."
    };
  } catch (err) {
    return {
      "status": "failed",
      "message": "ERROR : Highlight the element from loaded model."
    };
  }
}

/**
 * Applies highlight material to single element 
 * @param {string} element_id 
 * @returns {Object} - Return success or error messages 
 * { status:  mesage: }
 */
export function highlightedElement(element_id) {
  var scope = this;
  try {
    scope.clearHighlights();
    if (scope.modelScene.children.length != 0) {
      scope.applyHighlightMaterial(element_id);
      var returnValue = {
        "status": "success",
        "message": "Highlighted element API"
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Model is not loaded in viewer."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error: " + err.message
    }
    return returnValue;
  }
}


/**
 * highlight element flag check
 * @param {boolean} status 
 * @returns {Object} - Return success or error messages 
 * { status:  mesage: }
 */
export function highlightCheck(status) {
  var scope = this;
  try {
    if (status != undefined || status != null) {
      scope.highlightElementFlagCheck = status;
      //viewerMgrInstance.render();
      var returnValue = {
        "status": "success",
        "message": "Highlighting enabled successfully."
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Status is either undefined or null."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error: " + err.message
    }
    return returnValue;
  }
}
